/**
 * Created by mukund on 10/30/17.
 */

angular.module('mediacloudApp')
    .directive('recorder', ['$state', '$interval', '$timeout', 'WebcamService', 'CaptureService', 'BatchService', 'BaseFileService', 'JobService', 'UploadErrors', function($state, $interval, $timeout, WebcamService, CaptureService, BatchService, BaseFileService, JobService, UploadErrors){

        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'scripts/components/lms/directives/recorder/recorder.html',
            scope: {
                isEnabled: '=',
                file: '=',
                parent: '=',
                errors: '=',
                cancel: '&',
                add: '&'
            },
            link: function(scope, element, attr) {

                // Kurento Functionality
                var recordingFilePath;

                scope.webcam = {};
                scope.webcam.isAudioOnly = false;

                scope.file.needsTranscoding = true;
                scope.file.state = 'IDLE';

                WebcamService.setState('IDLE');

                $interval(function () {
                    if(WebcamService.getState() !== scope.webcam.state){
                        scope.webcam.state = WebcamService.getState();
                    }
                }, 100);

                var startWebcam = function(){
                    WebcamService.startLocalStream(document.getElementById('localVideo'));
                    recordingFilePath = WebcamService.getRecordingFilePath();
                    angular.element('.recordtimer').text("00 : 00 : 00");
                };

                scope.$watch('isEnabled', function(){
                    if(scope.isEnabled) {
                        // Check for viewing inside iframe
                        scope.supported = WebcamService.isSupported();
                        $timeout(function(){
                            if (scope.supported) {
                                startWebcam();
                            }
                        });
                    }
                });

                scope.startRecording = function() {
                    WebcamService.startRecording(document.getElementById('remoteVideo'), angular.element('.recordtimer'));
                };

                scope.stopRecording = function() {
                    WebcamService.stopRecording();
                };

                scope.playRecording = function () {
                    WebcamService.playRecording(document.getElementById('videoReview'), document.getElementById('localVideo'));
                };

                scope.showHeader = $state.params.windowType && ($state.params.windowType === "popup");

                scope.disableRecorder = function(){
                    scope.isEnabled = false;
                    WebcamService.destroyWebcam();
                };

                scope.discardRecording = function(){
                    WebcamService.destroyWebcam();
                    var timer = $interval(function () {
                        if(WebcamService.isIdle()){
                            scope.showDiscardDialog = false;
                            startWebcam();
                            $interval.cancel(timer);
                        }
                    }, 100);
                };

                scope.showMetadataForm = function(){
                    scope.showMetadata = true;
                    WebcamService.setState('REVIEWED');
                };

                scope.toggleWebcamType = function(){
                    if(scope.webcam.isAudioOnly){
                        WebcamService.setType('AUDIO');
                    } else {
                        WebcamService.setType('VIDEO');
                    }
                    WebcamService.destroyWebcam();
                    startWebcam();
                };

                scope.saveRecording = function(){

                    console.log("Uploading file to Hotfolders...");

                    scope.file.uploadStarted = true;

                    var captureResource = new CaptureService.saveCapture({filePath: recordingFilePath});
                    captureResource.$save(function(captureFile){

                        console.log("File successfully uploaded to Hotfolders with fileId: " + captureFile.id);

                        var addBatchRequest = new BatchService.CreateBatch();
                        addBatchRequest.$save(function(batch){
                            if(batch) {
                                console.log("Batch successfully created with batchId: " + batch.batchId);

                                scope.file.fileId = captureFile.id;

                                var addBaseFileRequest = {};
                                addBaseFileRequest.batchId = batch.batchId;
                                addBaseFileRequest.collectionId = scope.file.metadata.destination.cid;
                                addBaseFileRequest.fileName = scope.file.metadata.title;
                                addBaseFileRequest.autoPublish = true;
                                addBaseFileRequest.fileId = captureFile.id;
                                addBaseFileRequest.sendForCaptioning = scope.file.sendForCaptioning;
                                if(captureFile.thumbnails) {
                                    addBaseFileRequest.thumbnailId = captureFile.thumbnails[0].id;
                                    scope.file.thumbnails = captureFile.thumbnails;
                                    scope.file.selectedThumbnail = captureFile.thumbnails[0];
                                } else {
                                    scope.file.selectedThumbnail = {id: '000', url: 'assets/images/noThumbnail.jpg'};
                                    scope.file.thumbnails = [];
                                    scope.file.thumbnails.push(scope.file.selectedThumbnail);
                                }

                                var baseFileResource = new BaseFileService.AddBaseFile(addBaseFileRequest);
                                baseFileResource.$save(function(baseFile){
                                    scope.file.mediacloudFileId = baseFile.id;

                                    var createJobRequest = {};
                                    createJobRequest.batchId = batch.batchId;
                                    createJobRequest.fileId = scope.file.fileId;
                                    createJobRequest.profiles = [];
                                    createJobRequest.transcodeFile = true;

                                    // Create a job for the file
                                    JobService.CreateJob().getNewJob(createJobRequest)
                                        .then(function(job){
                                            if(job) {
                                                console.log("Job successfully created with jobId: " + job.jobId);
                                                scope.file.jobId = job.jobId;
                                                scope.file.isSuccess = true;
                                                scope.file.uploadComplete = true;
                                                scope.file.state = 'COMPLETED';
                                            }
                                        }, function(){
                                            scope.errors.push({id: 'ee' + Date.now(), msg: UploadErrors.CREATE_JOB.formatMessage({name: scope.file.metadata.title})});
                                            scope.cancel();
                                        });
                                }, function(){
                                    scope.errors.push({id: 'ee' + Date.now(), msg: UploadErrors.CREATE_BASEFILE.formatMessage({name: scope.file.metadata.title})});
                                    scope.cancel();
                                });
                            } else {
                                scope.errors.push({id: 'ee' + Date.now(), msg: UploadErrors.CREATE_BATCH});
                            }
                        }, function () {
                            scope.errors.push({id: 'ee' + Date.now(), msg: UploadErrors.CREATE_BATCH});
                        });
                    });
                };

            }
        }

    }]);
